import React from 'react';

import Form from './Form';
import * as API from '../../core/api';
import { catchFormErrors } from '../../utils/form-errors';

class Edit extends React.Component {
  handleSubmit = ({ status }) => {
    const { onSuccess, project } = this.props;

    return API.post(`users/me/projects/${project._id}`, {
      status,
    })
      .then(onSuccess)
      .catch(catchFormErrors);
  };

  render() {
    const { status } = this.props;

    return <Form initialValues={{ status }} onSubmit={this.handleSubmit} />;
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/projects/edit-status/index.js